import React from 'react';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-[#f8f4f2] text-gray-700 mt-16 pt-10 pb-6 px-6 rounded-t-3xl shadow-inner">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Logo + Nombre */}
        <div className="flex flex-col items-center md:items-start">
          <img src={logo} alt="Logo" className="h-12 mb-2" />          
          <p className="text-sm text-gray-500 mt-2">
            Estética avanzada y bienestar personalizado.
          </p>
        </div>

        {/* Enlaces */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Navegación</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="#inicio" className="hover:text-primary">Inicio</a></li>
            <li><a href="#servicios" className="hover:text-primary">Servicios</a></li>
            <li><a href="#nosotros" className="hover:text-primary">Nosotros</a></li>
            <li><a href="#contacto" className="hover:text-primary">Contacto</a></li>
          </ul>
        </div>

        {/* Contacto */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Contáctanos</h3>
          <p className="text-sm">Unicentro Virginia Piso 1 Local 1-01, Maracaibo</p>
          <p className="text-sm">+58 424-6440230</p>
          <p className="text-sm">Calle Paris Torre el primero Piso 4 Oficina 4, Caracas</p>
          <p className="text-sm">+58 412-6449753</p>
          <p className="text-sm">info@clinicacorium.com</p>
          <div className="flex justify-center md:justify-start space-x-4 mt-3 text-primary text-lg">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaWhatsapp /></a>
          </div>
        </div>
      </div>

      {/* Derechos reservados */}
      <div className="mt-8 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} Centro Medico Laser Corium. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
